import React from 'react';
import { string, number } from 'prop-types';
import { Alert } from '@material-ui/lab';

import meetingConstants from 'Services/constants/meetings';
import styles from './styles.scss';

const MEETING_WARN_TIME = 60 * 60 * 3; // 3 hours

const MeetingInfoWarnings = ({ status, startsAt }) => {
  if (!status) return null;
  if (status === meetingConstants.statuses.cancelled) {
    return (
      <Alert
        classes={{ root: styles.alert }}
        severity='error'
        variant='filled'
      >
        This consult has been cancelled by the practitioner.
      </Alert>
    );
  } else if (status === meetingConstants.statuses.inactive) {
    return (
      <Alert
        classes={{ root: styles.alert }}
        severity='error'
        variant='filled'
      >
        This consult has ended.
      </Alert>
    );
  }
  if (Math.floor(Date.now() / 1000) - startsAt > MEETING_WARN_TIME) {
    return (
      <Alert
        classes={{ root: styles.alert }}
        severity='warning'
        variant='outlined'
      >
        This consult was due to start more than 3 hours ago, the practitioner may no longer be present.
      </Alert>
    );
  }
  return null;
};

MeetingInfoWarnings.propTypes = {
  status: string,
  startsAt: number,
};

export default MeetingInfoWarnings;
